import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    attendancesList: [],
    attendanceID: "",
    attendancesArray: [],
    emplAttendances: [],
    selectedAttendances: null,
  };
  
  const mutations = {
    LIST_ATTENDANCES(state, attendances) {
      state.attendancesList = attendances;
    },
    SET_EMPLOYEES_ATTENDANCES(state, attendances) {
      state.emplAttendances = attendances;
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
      }
    },

    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    RESET_SEARCH_FILTERS(state){
    }
  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    async createAttendance({ commit,state }, formData) {
        return axios.post('api/v1/create-attendance/', formData)
        .then((response)=>{
            return response;
        })
        .catch((error)=>{
            throw error;
        })
    },
    fetchAttendanceEmployees({ commit,state }, formData) {
        axios.post(`api/v1/employee-attendances-search/`,formData)
        .then((response)=>{
            commit('SET_EMPLOYEES_ATTENDANCES',response.data.results);
        })
        .catch((error)=>{
          console.log(error.message);
        })
        
    },
    fetchAttendances({ commit,state }, formData) {
        axios.post(`api/v1/attendances-search/`,formData)
        .then((response)=>{
            commit('LIST_ATTENDANCES',response.data);
        })
        .catch((error)=>{
          console.log(error.message);
        })
        
    },
    deleteAttendance({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Attendance?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Attendance!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-attendance/`,formData)
        .then((response)=>{
          if(response.data.msg == "Success"){
              Swal.fire("Poof! Attendance removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Attendance",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Attendance has not been deleted!`);
      }
    })
  },

  };
  
  const getters = {
    getAttendanceStatus: () => {
      const statusList = [
        { text: "Present", value: "Present" },
        { text: "Absent", value: "Absent" },
        { text: "Leave", value: "Leave" },
        { text: "Holiday", value: "Holiday" },
        { text: "Off Day", value: "Off Day" },
      ];

      return statusList;
    },
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  